const options = {
  5: "bg-violet-400/5",
  10: "bg-violet-400/10",
  25: "bg-violet-400/25",
  50: "bg-violet-400/50",
  75: "bg-violet-400/75",
  90: "bg-violet-400/90",
  100: "bg-violet-400",
};

const from = {
  5: "from-violet-400/5",
  10: "from-violet-400/10",
  25: "from-violet-400/25",
  50: "from-violet-400/50",
  75: "from-violet-400/75",
  90: "from-violet-400/90",
  100: "from-violet-400",
};

export default function getBackgroundViolet400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
